import { Box, Link, Stack, Typography } from "@mui/material";
import CopyableTypography from "components/Typography/CopyableTypography";

export const CopyableListDisplay = ({
  items,
  label,
  viewAllClick,
  maxItemsShownInline,
}: {
  label: string;
  items: Array<string | number>;
  maxItemsShownInline: number;
  viewAllClick: () => void;
}) => {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, fontWeight: 500 }}>
        {label}
      </Typography>
      {items.length > 0 ? (
        <Stack gap={1}>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
            {items.slice(0, maxItemsShownInline).map((item) => (
              <CopyableTypography
                key={item}
                text={String(item)}
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  px: 1,
                  py: 0.25,
                  borderRadius: 1,
                  border: "1px solid",
                  borderColor: "divider",
                }}
              />
            ))}
          </Stack>

          {items.length > maxItemsShownInline && (
            <Link
              width={"fit-content"}
              component="button"
              variant="body2"
              onClick={viewAllClick}
              sx={{ cursor: "pointer" }}
            >
              View all {items.length}
            </Link>
          )}
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary">
          None
        </Typography>
      )}
    </Box>
  );
};
